import ConfigurableMargin from './_configurable-margin.js'
import ConfigurableBackground from './_configurable-background.js'

export default {
  name: 'RangeInput',
  values: {
    class: 'range-input',
    style: {
      input: {
        height: '4px',
        width: undefined,
        zIndex: 1,
        backgroundImage: undefined,
        disabledBackgroundImage: undefined,
        backgroundRepeat: 'no-repeat',
        pointerEvents: 'auto',
        borderRadius: undefined,
        $mixin: [
          {
            configSet: ConfigurableMargin,
          },
        ],
      },
      focus: {
        outline: 'none',
      },
      thumb: {
        border: 'none',
        height: '20px',
        width: '20px',
        cursor: 'pointer',
        borderRadius: '50%',
        pointerEvents: 'auto',
        $mixin: [
          {
            configSet: ConfigurableBackground,
          },
        ],
      },
      track: {
        cursor: 'pointer',
      },
      disabled: {
        thumb: {
          $mixin: [
            {
              configSet: ConfigurableBackground,
            },
          ],
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
